module.exports = __webpack_public_path__ + "img/amount_paid.284ba844.svg";